import * as types from "./ActionTypes";
import InitialState from "Store/InitialState";

export default function userCourseRoleReducer(
  state = InitialState.userCourseRole,
  action
) {
  switch (action.type) {
    case types.SET_USER_COURSE_ROLE:
      return action.payload;

    default:
      return state;
  }
}
